import { CheckCircleIcon, ExclamationIcon, ExclamationCircleIcon, ShieldExclamationIcon } from '@heroicons/react/outline';
import { startCase } from 'lodash-es';

const FAILURE = {
  label: 'Failed',
  tooltip: 'This type of failure usually indicates a problem with the data in the source system. Please review and fix the issues and try again. If the problem persists, contact the system administrator.',
  Icon: ExclamationIcon,
  iconColor: 'stroke-red-600',
  textColor: 'text-red-800',
};

const ERROR = {
  label: 'Error',
  tooltip: 'This type of failure usually indicates a problem with the system. Please contact the system administrator.',
  Icon: ExclamationCircleIcon,
  iconColor: 'stroke-red-700',
  textColor: 'text-red-900',
};

const STEP_RESULT_TYPE = {
  SUCCEEDED: {
    value: 'succeeded',
    label: 'Succeeded',
    tooltip: null,
    Icon: CheckCircleIcon,
    iconColor: 'stroke-green-600',
    textColor: 'text-green-800',
  },
  SKIPPED: {
    value: 'skipped',
    label: 'Skipped',
    tooltip: null,
    Icon: CheckCircleIcon,
    iconColor: 'stroke-cyan-600',
    textColor: 'text-cyan-800',
  },
  NOT_PROCESSED: {
    value: 'not_processed',
    label: 'Not Processed',
    tooltip: 'This type of failure means that migration wasn\'t attempted due to failures in dependent steps. Please review the dependent step failures and try again. If the problem persists, contact the system administrator.',
    Icon: ShieldExclamationIcon,
    iconColor: 'stroke-orange-600',
    textColor: 'text-orange-800',
  },
  VALIDATION_FAILED: {
    value: 'validation_failed',
    ...FAILURE,
  },
  BROKEN_STATE: {
    value: 'broken_state',
    ...FAILURE,
  },
  EXTERNAL_ERROR: {
    value: 'external_error',
    ...ERROR,
  },
  INTERNAL_ERROR: {
    value: 'internal_error',
    ...ERROR,
  },
};

export default Object.freeze({
  ...STEP_RESULT_TYPE,
  find: (value) => Object.values(STEP_RESULT_TYPE).find(({ value: stepValue }) => stepValue === value) ?? {
    value,
    label: startCase(value),
    tooltip: '',
    Icon: ExclamationIcon,
    iconColor: 'stroke-red-600',
    textColor: 'text-red-800',
  },
  values: () => Object.values(STEP_RESULT_TYPE).map(({ value }) => value),
});
